<template>
  <div>
    <div class="d-flex align-center">
      <div
        class="d-flex align-center"
        :class="{ 'cursor-pointer': $isMobile }"
        role="button"
        tabindex="0"
        v-on=" $isMobile ? { click: toggleFaqs } : {}"
      >
        <v-icon
          v-if="$isMobile"
          small
          class="mr-2 primary-grey--text"
        >
          {{ showFaqs ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
        </v-icon>
        <div class="text-subtitle-1 font-weight-regular primary-grey--text">
          Today&apos;s Top Questions
        </div>
      </div>

      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-icon
            small
            class="ml-2 text--secondary"
            v-bind="attrs"
            v-on="on"
          >
            mdi-help-circle-outline
          </v-icon>
        </template>
        <span>
          Today&apos;s Top Questions do not count toward your "Questions Asked".
          Click one to see the response.
        </span>
      </v-tooltip>

      <v-btn
        v-if="!$isMobile"
        small
        outlined
        text
        class="ml-2 primary-grey--text text-none font-weight-medium"
        :disabled="isSinoaLoading"
        @click="toggleFaqs"
      >
        {{ showFaqs ? 'Hide' : 'Show' }}
        <v-icon
          small
          right
        >
          {{ showFaqs ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
        </v-icon>
      </v-btn>
    </div>

    <template v-if="showFaqs">
      <div
        v-if="isLimitReached"
        class="mt-2 text-caption primary-grey--text font-weight-regular"
      >
        You&apos;ve used all your free questions. But don&apos;t worry, answers
        for Most Frequent Questions are still available!
      </div>
      <GCarousel
        :max-items="5"
      >
        <GCarouselItem
          v-for="(item,index) in faqItems"
          :key="index"
          class="mx-0"
        >
          <v-card
            class="d-inline-flex flex-column justify-center align-center text-center
                   rounded-xl px-4 py-2 ma-1 elevation-1 faq-card"
            :disabled="isSinoaLoading"
            @click="handleFaqClick(item)"
          >
            <span class="text-body-2 primary-grey--text text-decoration-none text-hover-underline">
              {{ item.question }}
            </span>
          </v-card>
        </GCarouselItem>
      </GCarousel>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex';
import GCarousel from '@/components/generic/GCarousel.vue';
import GCarouselItem from '@/components/generic/GCarouselItem.vue';
import { datadogRum } from '@datadog/browser-rum';

export default {
  name: 'FrequentQuestionsCarousel',

  components: {
    GCarousel,
    GCarouselItem,
  },

  computed: {
    ...mapState('chatbot', ['faqItems', 'showFaqs']),
    ...mapState('app', ['isMimic']),
    ...mapGetters('chatbot', ['isLimitReached', 'isSinoaLoading']),

    hasSeenPSA() {
      return Boolean(localStorage.getItem('sinoaPSAShownDate'));
    },
  },

  methods: {
    ...mapMutations('chatbot', ['setShowFaqs']),
    ...mapActions('chatbot', ['showStoredAnswerWithStream']),

    toggleFaqs() {
      if (!this.isSinoaLoading) this.setShowFaqs(!this.showFaqs);
    },

    handleFaqClick(item) {
      this.showStoredAnswerWithStream({ ...item, question_type: 'faq' });
      datadogRum.addAction('Sinoa: Click FAQ', {
        source: 'FrequentQuestionsCarousel',
        faqItem: item,
        isMobile: this.$isMobile ?? null,
        isMimic: this.isMimic,
      });
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.faq-card {
  width: 400px;
}
</style>
